export default __webpack_public_path__ + "static/media/section2.6ab3110a.jpg";